module.exports = __webpack_public_path__ + "img/hand_course_content.8a9eedee.png";